export enum PermissionGroupsEnum {
  FULFILLMENT_MODULE = 'FULFILLMENT_MODULE',
  DOC_INGESTION_MODULE = 'DOC_INGESTION_MODULE',
  BOTBUILDER_MODULE = 'BOTBUILDER_MODULE',
  ANALYTICS_MODULE = 'ANALYTICS_MODULE'
}
